module.exports = __webpack_public_path__ + "img/375.8dd169ef.jpg";